// extracted by mini-css-extract-plugin
export default {"btn":"PDFLink_btn__2wpjc","btn_download":"PDFLink_btn_download__5IuNg"};